<template>
    <div class="all">
        <img src="../../assets/img/title.png" class="title" />
        <div class="title_text">研习营电子证书打印</div>
        <div class="select_box">
            <div class="input_box">


                <vs-select style="width:300px;margin:auto" label-placeholder="研习届次" placeholder="Select" v-model="type"
                    primary>
                    <vs-option label="7" value="7">
                        7
                    </vs-option>
                    <vs-option label="8" value="8">
                        8
                    </vs-option>
                    <vs-option label="9" value="9" checked>
                        9
                    </vs-option>
                    <template #message-danger v-if="!type">
                        研习届次必填
                    </template>
                </vs-select>
            </div>

            <div class="input_box">


                <vs-select style="width:300px;margin:auto;margin-top:40px" label-placeholder="证书类型" placeholder="Select"
                    v-model="Volunteer" primary>
                    <vs-option label="结业证书" value="结业证书">
                        结业证书
                    </vs-option>
                    <vs-option label="志愿服务证书" value="志愿服务证书" checked>
                        志愿服务证书
                    </vs-option>

                    <template #message-danger v-if="!Volunteer">
                        证书类型必填
                    </template>
                </vs-select>
            </div>

            <div class="input_box">
                <vs-input label-placeholder="姓名" v-model="username" primary>
                    <template #message-danger v-if="!username">
                        姓名必填
                    </template>
                </vs-input>
            </div>
            <div class="input_box">
                <vs-input :label-placeholder="label" v-model="idcard" primary>

                    <template #message-danger v-if="!idcard">
                        {{ label }}必填
                    </template>
                </vs-input>
            </div>

        </div>

        <vs-button :disabled="!idcard || !username || !type" success flat @click="signpdffun">确 定</vs-button>


        <vs-card v-if="url">
            <template #img>
                <div style="width: 450px">
                    <pdf ref="pdf" @loaded="loadover()" :src="url"> </pdf>
                </div>
            </template>
            <template #text>
                <vs-button block success icon @click="downloadfile">
                    下载
                </vs-button>
            </template>
        </vs-card>


        <a href="javascript:void(0);" id="oDownLoad" style="display:none;">下载a</a>

        <!-- <div style="width: 100%">
            <pdf ref="pdf" @loaded="loadover()" :src="url"> </pdf>
        </div> -->
        <van-overlay :show="iframeloading" style="    padding-top: calc(50vh - 20px);">
            <van-loading color="#1989fa" />
        </van-overlay>
    </div>
</template>
<script>
// import pdf from 'vue-pdf'
import pdf from "vue-pdf";
import { GuoHeDownload } from "@/api/data/view"; //
export default {
    components: {
        pdf,
    },
    data() {
        return {

            username: '',
            idcard: '',
            type: '9',

            active: 1,

            iframeloading: false,
            iframeshow: false,
            iframe: ``,

            options4: [],
            value1: '',
            src: "",
            name: "",
            loading: null,
            url: '',
            prindid: null,
            viewid: null,
            selectloading: false,


            label: '台湾身份证',

            viewlist: [{
                id: 1,
                name: 1
            }],
            Volunteer: '结业证书',
        }
    },
    watch: {
        type: function () {
            this.changelabel()
        },
        Volunteer: function () {
            this.changelabel()
        }
    },
    methods: {
        changelabel() {
            if (this.Volunteer == '志愿服务证书') {
                this.label = '学号'
                return
            }
            else if (this.type == 7) {
                this.label = '台胞证'
            } else {
                this.label = '台湾身份证'
            }
        },
        async valuechange(value) {
            this.value1 = value;
            this.signpdffun();
        },
        async downloadfile() {
            let path = this.url;

            const u = navigator.userAgent;
            console.log(u, "u");
            const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            if (isAndroid) {
                // 安卓终端使用iframe
                window.open(path);
            } else if (isiOS) {
                var odownLoad = document.getElementById('oDownLoad');
                odownLoad.href = path;
                odownLoad.download = "";
                odownLoad.click();

            } else {
                // 1.如果是地址
                window.open(path);
                //2.如果是文件流
            }
        },
        signpdffun() {
            this.iframeloading = true;
            this.url = '';
            this.iframe = '';
            this.iframeshow = false;

            GuoHeDownload(this.username, this.idcard, this.type).then(
                (res) => {
                    this.url = res;
                    //  this.url = res;
                    //this.url = "https://bddy.wmu.edu.cn/1684895782793.pdf";
                    // this.iframe = `https://verify.ink/viewer?url=${this.url}&search=false&sign=false&show-signature-if-present=false&notify-if-not-signed=false&download=true&filename=1.pdf`
                    this.iframeshow = true;
                    console.log(123);
                }
            ).catch(error => {
                console.error(error)
            })
                .finally(_ => {
                    console.log(_);
                    this.iframeloading = false;
                })
        },
        loadover() {
            this.loading.close();
        },
    },
    async mounted() {

        if (this.$route.query && this.$route.query.viewid) {
            this.viewid = this.$route.query.viewid;
        } else {
            this.$vs.notification({
                progress: "auto",
                color: "danger",
                position: "top-center",
                title: "错误信息",
                text: "viewid为空",
            });
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .vs-button {
    width: 300px;
    margin: auto;
}

::v-deep .vs-input-content {
    margin: auto;
    margin-top: 1rem;
}

::v-deep .vs-input {
    width: 300px;
}

::v-deep .vs-card {
    max-width: 375px;
    padding-top: 20px;
}

::v-deep .vs-select__label {
    margin-bottom: 12px;
}

.title_text {
    font-size: 1.2rem;
    font-family: 'fangsong';
    margin: 2rem 0 1rem 0;
    margin-bottom: 1rem;
}

.title {
    width: 55%;
    max-width: 300px;
}

.all {
    background: #f5f5f5;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    padding: 2rem 0.2rem;
    box-sizing: border-box;
    overflow-x: hidden;
}

.input_box {
    margin-bottom: 1rem;
}

.aaaa {
    margin-top: 5vh;
}

iframe {
    border: 0px;
    height: 420px;
    width: 100%;
}

::v-deep .vs-card {
    margin: auto;
}

::v-deep .vs-card__img {
    max-height: 500px;
    padding-top: 1rem;
}

@media screen and (min-height: 667px) {
    .all {
        padding: 1rem 0.2rem;
    }

    .aaaa {
        margin-top: 1vh;
    }
}

@media screen and (min-height: 700px) {
    .all {
        padding: 3rem 0.2rem;
    }

    .aaaa {
        margin-top: 2vh;
    }
}

@media screen and (min-height: 800px) {
    .all {
        padding: 3rem 0.2rem;
    }

    .aaaa {
        margin-top: 2rem;
    }
}


@media screen and (min-height: 896px) {
    .all {
        padding: 3rem 0.2rem;
    }

    .aaaa {
        margin-top: 2rem;
    }
}

.select_box {
    padding: 0 1rem;
}

.vs-select-content {
    max-width: 100%;
}
</style>